import React, { Component } from "react";
import styles from "./TitleH2.module.css";

function TitleH2({ children, className }) {
  return (
    <>
      <div className={`${styles.h2Cont} ${className}`}>
        <h2>{children}</h2>
        <div className={`${styles.topLine}`}></div>
      </div>
    </>
  );
}

export default TitleH2;
